jQuery(document).ready(function( $ ) {

    var cred = ' | <a class="text-body" href="https://www.aestheticbrandmarketing.com/services/online-visibility/?utm_source=Schusterman+Plastic+Surgery&amp;utm_medium=link&amp;utm_campaign=plasticsurgerymarketing" target="_blank" rel="noopener">Plastic Surgery Marketing</a> by <a href="https://www.aestheticbrandmarketing.com/?utm_source=Schusterman+Plastic+Surgery&amp;utm_medium=link&amp;utm_campaign=abmlogo" target="_blank" rel="noopener"><span class="screen-reader-text">Aesthetic Brand Marketing, Inc.</span><img src="https://www.drschusterman.com/wp-content/themes/schusterman/dist/images/abm-logo.svg" width="46" height="12" alt=""></a>';

    $(".footer-copyright p").append(cred);

	//add dropdown to all item with submenu
	$('#slide-menu li.menu-item-has-children > a').append('<i class="fas fa-caret-down dropdown"></i>');


	//show submenu on click
	$(".dropdown").on("click", function(e) {
		e.stopPropagation();
		e.preventDefault();
		$(this).toggleClass('dropdown-active');
		$(this).parent().parent().find('ul.sub-menu').first().toggleClass('sub-menu-expanded');
	});


	// fix anchor links positioning
	$(function () {
		$('a[href*=\\#]:not([href=\\#])').click(function () {
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&& location.hostname == this.hostname) {

				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					$('html,body').animate({
						scrollTop: target.offset().top + 20 //offsets for fixed header
					}, 1000);
					return false;
				}
			}
		});
		//Executed on page load with URL containing an anchor tag.
		if ($(location.href.split("#")[1])) {
			var target = $('#' + location.href.split("#")[1]);
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top - $headerHeight //offset height of header here too.
				}, 1000);
				return false;
			}
		}
	});


});
